"use strict";export*from"lit/decorators.js";
//# sourceMappingURL=decorators.js.map
